$(document).ready(function() {
    $('body').on('click', '[name="checkout"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        $("#agree_chk_error").show();
        // alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  $("#agree").click(function(){
    $("#agree_chk_error").hide();
  });
  });